<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/projects/add"
      search_title="إضافه مشروع"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->
    <!-- <main-filter
      @getResult="setRows"
      categories
      code
      price
      withCategory
      withSizes
      withColors
    /> -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="fadeIn" v-else>
      <!-- Start Main Section -->
      <main>
        <v-data-table
          class="elevation-1 thumb diff_table"
          :headers="headers"
          :items="rows"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:[`item.image`]="{ item }">
            <div class="item-with-img">
              <img
                :src="item.image"
                width="40"
                style="display: block;"
                :alt="item.name"
                @click="show_model_1"
              />
            </div>
          </template>
          <!-- Start:: Users Routes -->

          <template v-slot:[`item.category`]="{ item }">
            <span v-if="item.category">
              {{ item.category.name }}
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:[`item.title`]="{ item }">
            <div class="item-with-img">
              <p>{{ item.title }}</p>
            </div>
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <div>
              <v-switch
                v-model="item.is_active"
                @mousedown="toggleActive(item.id)"
              ></v-switch>
            </div>
          </template>

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <v-icon class="show" small @click="showItem(item)">
                fal fa-eye
              </v-icon>
              <v-icon
                class="edit"
                v-if="!canEdit"
                small
                @click="editItem(item)"
              >
                fal fa-edit
              </v-icon>
              <v-icon class="edit" small @click="addMeta(item)">
                fal fa-code
              </v-icon>
              <v-icon
                class="delete"
                v-if="!canDelete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="table-title title">المشاريع</h3>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>

      <!-- End Statistics Card-->
      <!-- Trying -->
      <!-- <div class="row">
        <div class="col-6 py-0 " v-for=" project in projects" :key="project.id">
        <ProjectCard :project="project" @deleteThisProject="deleteItem"/>
      </div>
      </div> -->
      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container tw-text-center mb-5 d-flex justify-content-end"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
    <v-dialog v-model="dialogPublish" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          هل تريد تغير حالة عرض المشروع في الموقع ؟
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#fff" @click="confirmToggleActive">
            {{ $t("table.deletedialog.ok") }}
          </v-btn>
          <v-btn color="#fff" @click="dialogPublish = false">
            {{ $t("table.deletedialog.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete dialog -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("table.deletedialog.areYouSure") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#fff" @click="deleteItemConfirm">
            {{ $t("table.deletedialog.ok") }}
          </v-btn>
          <v-btn color="#fff" @click="dialogDelete = false">
            {{ $t("table.deletedialog.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import MainFilter from '../../../components/Filters/MainFilter.vue'

export default {
  components: {
    // MainFilter,
    ProjectCard: () => import("../../../components/UI/cards/project.vue"),
  },
  data() {
    return {
      // ========== Breadcrumbs
      projects: [],
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.projects.title"),
          disabled: false,
          href: "/projects",
        },
        {
          text: this.$t("breadcrumb.projects.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      dialogPublish: false,
      itemtoActive: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: null,
        items_per_page: 15,
      },
      showItems: [
        {
          id: 1,
          value: 5,
        },
        {
          id: 2,
          value: 10,
        },
        {
          id: 1,
          value: 20,
        },
      ],

      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "الصورة",
            align: "center",
            value: "image",
            sortable: false,
          },
          {
            text: "المشروع",
            align: "center",
            value: "name",
            sortable: true,
          },
          {
            text: "الفئة",
            align: "center",
            value: "category",
            sortable: false,
          },
          {
            text: "تاريخ الاضافة",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          {
            text: "التحكم في العرض في الموقع",
            align: "center",
            value: "is_active",
            sortable: false,
          },
          {
            text: "الاجراءات",
            align: "center",
            value: "actions",
            sortable: false,
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    toggleActive(id) {
      this.dialogPublish = true;
      this.itemtoActive = id;
    },
    confirmToggleActive() {
      this.axios({
        method: "PUT",
        url: `projects/${this.itemtoActive}/toggle_status`,
        // params: params,
      })
        .then((res) => {
          this.setRows();
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.dialogPublish = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.dialogPublish = false;
        });
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/projects/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/projects/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/projects/edit/" + item.id });
    },
    addMeta(item) {
      this.$router.push({ path: "/projects/meta/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `project/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.axios({
        method: "POST",
        url: `products/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("page", this.paginations.current_page);
      // console.log("dfgsahhbj")
      this.axios({
        method: "GET",
        url: "project",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.rows = res.data.data;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },

  // ======= hooks
  created() {
    this.canEdit = this.$permission.allowed("projects/edit/");
    this.canDelete = this.$permission.allowed("projects/delete");
    this.canAdd = this.$permission.allowed("projects/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss">
// .image {
//   width: 120px;
//   img {
//     width: 100%;
//   }
// }
.v-dialog__content .v-card .v-card__actions button {
  background: var(--secondColor) !important;
  color: #fff !important;
  font-size: 16px;
}
.v-dialog__content .v-card .v-card__actions button:last-of-type {
  background: #fa4248 !important;
  color: #fff !important;
  font-size: 16px;
}
</style>
